/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */

import type AbstractModel from '../core/AbstractModel';
import { getDateParser }  from '../core/config';

const doc = {
	boolean: (target: AbstractModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, false);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	date: (target: AbstractModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			const value = this.get(propertyKey);

			if (value === undefined) return undefined;

			return getDateParser()(value);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	number: (target: AbstractModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, 0);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	string: (target: AbstractModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, '')?.toString() || '';
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	json: (target: AbstractModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, []) || '';
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	model: (
		loader: () => (new (...args: any[]) => any),
		getId?: (target: any) => id | undefined,
	) => {
		return (target: any, key: string) => {
			const store = Symbol(key);

			Object.defineProperty(target, key, {
				get() {
					if (!this[store]) {
						const ClassRef = loader();
						this[store] = new ClassRef({
							...this.get(key),
							id: getId?.(this) || this.get(`${key}.id`),
						});
					}
					return this[store];
				},
				enumerable: true,
				configurable: true,
			});
		};
	},
};

export default doc;
